import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Atmosphere } from "@/components/atmosphere/Atmosphere";
import { useSeo } from "@/hooks/use-seo";

export default function NotFound() {
  useSeo({
    title: "Record not found | The Fractured Five",
    description: "The file you requested does not exist.",
    path: "/404",
    noindex: true
  });

  useEffect(() => {
    document.title = "Record not found | The Fractured Five";
  }, []);

  return (
    <>
      <Atmosphere />
      <div className="relative z-10 flex min-h-screen items-center justify-center px-4">
        <div className="panel max-w-md p-7 text-center">
          <p className="stamp">No such record</p>
          <h1 className="mt-5 text-3xl font-semibold">404</h1>
          <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
            The file you requested does not exist, or every system insists it
            never did.
          </p>
          <Link
            to="/"
            className="mt-6 inline-flex h-11 items-center justify-center rounded-[10px] bg-primary px-5 font-mono text-[11px] uppercase tracking-[0.16em] text-primary-foreground transition-colors duration-150 hover:bg-[hsl(174_72%_36%)]"
          >
            Return to the dossier
          </Link>
        </div>
      </div>
    </>
  );
}
